<template>
    <ul class="article__list">
        <li><p class="article__public-offer-centered"><strong><br></strong></p></li>
        <li>
            <div class="article__public-offer-item">
                <div><strong>Bat Norton</strong></div>
                <div><strong>Email:&nbsp;<a href="mailto:info@batnorton.com"
                                            class="article__link">info@batnorton.com</a></strong></div>
                <div><strong>Tel:&nbsp;+66 082 585 1554</strong></div>
            </div>
            <p class="article__public-offer-item"><br>{{trans("Public offer agreement on the sale of goods of the online shop")}}
                'Bat Norton'</p>
            <div class="article__public-offer-item"><strong><br>1.{{trans("General Provisions")}}</strong>
                <div class="article__public-offer-sub-item"><strong>1.1.</strong>{{trans("Bat Norton Co.,Ltd, hereinafter referred to as the «Seller», publishes the Public Offer for the sale of goods based on the samples presented on the official website of the Seller")}} https://batnorton.com/<a
                        href="https://us.batnorton.com/" class="article__link"></a></div>
                <div class="article__public-offer-sub-item"><strong>1.2.</strong>{{trans("In this offer, unless the context otherwise requires, the following terms have the following meanings")}}:
                    <ul class="article__list">
                        <li>«{{trans("Offer")}}» - {{trans("a public offer of the Seller addressed to any natural person (citizen) to conclude a sale and purchase agreement (hereinafter referred to as the «Agreement») with him on the existing terms and conditions contained in the Agreement, including all its annexes")}}.
                        </li>
                        <li>«{{trans("Buyer")}}» - {{trans("a natural person who has entered into the Contract with the Seller on the terms and conditions contained in the Contract")}}.
                        </li>
                        <li>«{{trans("Acceptance")}}» - {{trans("full and unconditional acceptance by the Buyer of the terms and conditions of the Contract")}}.
                        </li>
                        <li>«{{trans("Goods")}}» - {{trans("a list of items from the assortment presented on the official website")}}.</li>
                        <li>«{{trans("Order")}}» - {{trans("individual items from the assortment list of the Goods specified by the Buyer when placing an order on the website or through the Operator")}}.
                        </li>
                        <li>«{{trans("Delivery")}}» - {{trans("courier services for delivery of the Order")}}.</li>
                    </ul>
                </div>
            </div>
            <div class="article__public-offer-item"><strong><br>2. {{trans("Subject of the Contract")}}</strong>
                <div class="article__public-offer-sub-item"><strong>2.1.</strong>{{trans("The Seller shall sell the Goods in accordance with the current price list published on the Seller's website")}} https://batnorton.com/,{{trans( "and the Buyer shall pay for and accept the Goods in accordance with the terms and conditions of this Agreement")}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>2.2.</strong>{{trans("This Agreement and its annexes are official documents of the Seller and an integral part of the offer")}}.
                </div>
            </div>
            <div class="article__public-offer-item"><strong><br>3. {{trans("Order placement")}}</strong>
                <div class="article__public-offer-sub-item"><strong>3.1.</strong>&nbsp;{{trans("The Buyer shall place an order for the Goods via the Internet site")}} https://batnorton.com/.
                </div>
                <div class="article__public-offer-sub-item"><strong>3.2.</strong>&nbsp;{{trans("When registering on the Seller's website, the Buyer undertakes to provide the following registration information about himself")}}:
                    <ul class="article__list">
                        <li>{{trans("surname")}}, {{trans("first name")}},</li>
                        <li>{{trans("actual delivery address")}};</li>
                        <li>{{trans("e-mail address")}};</li>
                        <li>{{trans("contact phone number")}} ({{trans("mobile")}}, {{trans("landline")}})</li>
                    </ul>
                </div>
                <div class="article__public-offer-sub-item"><strong>3.3.</strong>&nbsp;{{trans("text-1")}}&nbsp;
                    <strong>3.2.</strong>&nbsp;{{trans("of this Agreement")}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>3.4.</strong>{{trans("The Seller and the Operator are not responsible for the content and accuracy of the information provided by the Buyer when placing the Order")}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>3.5.</strong>{{trans("The Buyer is responsible for the accuracy of the information provided when placing the Order")}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>3.6.</strong>{{trans("text-2")}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>3.7.</strong>{{trans("All information materials presented on the website")}} https://batnorton.com/ {{trans("text-3")}}.
                </div>
            </div>
            <div class="article__public-offer-item"><strong><br>4. {{trans("Order fulfilment terms")}}</strong>
                <div class="article__public-offer-sub-item"><strong>4.1.</strong>{{trans("text-4")}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>4.2.</strong>{{trans("The Order shall be deemed delivered at the moment of its handover to the Buyer. By signing in the courier sheet, the Buyer confirms the fulfilment of the Order")}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>4.3.</strong>{{trans("If the Buyer provides unreliable contact details, the Seller shall not be liable for improper fulfilment of the Order")}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>4.4.</strong>{{trans("In case of improper execution of the Order delivery through the fault of the Seller, the Order shall be redelivered free of charge")}}.
                </div>
            </div>
            <div class="article__public-offer-item"><strong><br>5. {{trans("Payment for the Order")}}</strong>
                <div class="article__public-offer-sub-item"><strong>5.1.</strong>{{trans("Payment for the fulfilled Order is made in two ways: either by payment from VISA, Master Card bank cards via PayPal invoices or via PayPal payment system")}} (https://www.paypal.com/).
                </div>
                <div class="article__public-offer-sub-item"><strong>5.2.</strong>{{trans("text-5")}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>5.3.</strong>{{trans("text-6")}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>5.4.</strong>{{trans("Money is accepted only by cashless payment")}}.
                </div>
            </div>
            <div class="article__public-offer-item"><strong><br>6. {{trans("Delivery of the goods")}}.</strong>
                <div class="article__public-offer-sub-item"><strong>6.1.</strong>{{trans("text-7")}}
                </div>
                <div class="article__public-offer-sub-item"><strong>6.2.</strong>{{trans("text-8")}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>6.3.</strong>{{trans("text-9")}} https://batnorton.com/.
                </div>
            </div>
            <div class="article__public-offer-item"><strong><br>7. {{ trans("Return of the Order") }}</strong>
                <div class="article__public-offer-sub-item"><strong>7.1.</strong>{{trans("text-10")}}
                    info@batnorton.com {{trans("about the desire to return the goods")}}.
                    <ul class="article__list">
                        <li>{{trans("text-11")}}.
                        </li>
                        <li>{{
                                trans("text-12")
                            }}.
                        </li>
                        <li>{{trans('text-13')}}.
                        </li>
                    </ul>
                </div>
                <div class="article__public-offer-sub-item"><strong>7.2.</strong>{{trans("text-14")}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>7.3.</strong>{{trans("text-15")}}.
                </div>
            </div>
            <div class="article__public-offer-item"><strong><br>8. {{trans("Rights, duties and responsibilities")}}</strong>
                <div class="article__public-offer-sub-item"><strong>8.1.</strong>{{trans("text-16")}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>8.2.</strong>{{trans("text-17")}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>8.3.</strong>{{trans("text-18")}}.
                </div>
                <div class="article__public-offer-sub-item"><strong>8.4.</strong>{{trans("text-19")}}
                    https://batnorton.com/, {{trans("in the section")}} https://batnorton.com/contacts. {{trans("All received information is processed as soon as possible")}}.
                </div>
            </div>
            <p class="article__public-offer-centered"><strong><br>Bat Norton Co.,Ltd.</strong></p>
            <div class="Article__publicoffer">
                <div><strong>Legal entity number 0815565002608</strong></div>
                <div><strong>Address: 339/17 Soi Wachiratham Sathit 15, Sukhumvit Road 101/1, Bang Chak Sub-district,
                    Phra Khanong District, Bangkok, Thailand 10260</strong></div>
                <div><strong>Tel: +66 082 5851554</strong></div>
            </div>
        </li>
    </ul>
</template>

<script>
export default {}
</script>

<style scoped>

</style>
